// eslint-disable-next-line no-unused-vars
import React from 'react';

/* Used to conditionally wrap a component

Example use case:

<ConditionalWrapper
  condition={link}
  wrapper={children => <a href={link}>{children}</a>}
>
  <>
    <h2>{brand}</h2>
    <h3>{model}</h3>
    <img src={image} alt="" />
    <p>{description}</p>
    <p>{price}</p>
  </>
</ConditionalWrapper>

*/

const ConditionalWrapper = ({ condition, wrapper, children }) =>
  condition ? wrapper(children) : children;

export default ConditionalWrapper;
